/**
 * 간트 막대 오른쪽(또는 왼쪽) 자재파트너 라벨 — `거래처/전화` (W5-25).
 * 위치 계산은 호출부가 shipSideLabelPlacement 로 구해 넘김. 스타일은 시공파트너(반장) 라벨과 동일.
 */
interface Props {
  label: string
  side: 'right' | 'left'
  /** 막대 세로 위치(px) — 시공 라벨과 같은 barTop */
  top: number
  /** side=right 면 라벨 시작 x, side=left 면 라벨 끝 x (px, 5px 간격 포함 전) */
  anchorPx: number
}

export function ShipBarSideLabel({ label, side, top, anchorPx }: Props) {
  return (
    <div
      style={{
        position: 'absolute',
        top,
        ...(side === 'right'
          ? { left: anchorPx + 5 }
          : { left: anchorPx - 5, transform: 'translateX(-100%)' }),
        height: 20,
        display: 'flex',
        alignItems: 'center',
        fontSize: 9.5,
        fontWeight: 600,
        color: 'var(--shell-on-surface-2)',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 2,
      }}
    >
      {label}
    </div>
  )
}
